import React from 'react';
import { Chip } from '@material-ui/core';

import {
  Done,
  Close,
  Attachment,
  Language,
  PictureAsPdf,
  Image,
  CropOriginal,
  Description,
  AccessTime,
} from '@material-ui/icons';

import { Reviews, Archive } from '@mui/icons-material';

import { blue, green, red, yellow } from '@material-ui/core/colors';

import theme from '../theme';

export const getChip = (label: string) => {
  switch (label) {
    case 'scanned':
      return (
        <Chip
          label="Digitalizado"
          color="primary"
          icon={<Attachment style={{ color: '#fff' }} />}
          style={{ color: '#fff', fontWeight: 'bold' }}
        />
      );
    case 'active':
      return (
        <Chip
          label="Ativo"
          icon={<Done style={{ color: '#fff' }} />}
          style={{ background: green[700], color: '#fff', fontWeight: 'bold' }}
        />
      );
    case 'online':
      return (
        <Chip
          label="Online"
          icon={<Language style={{ color: '#fff' }} />}
          style={{ background: blue[700], color: '#fff', fontWeight: 'bold' }}
        />
      );
    case 'closed':
      return (
        <Chip
          label="Encerrado"
          icon={<Close style={{ color: '#fff' }} />}
          style={{ background: red[700], color: '#fff', fontWeight: 'bold' }}
        />
      );

    case 'pending':
      return (
        <Chip
          label="Pendente"
          icon={<AccessTime style={{ color: '#fff' }} />}
          style={{ background: yellow[800], color: '#fff', fontWeight: 'bold' }}
        />
      );

    case 'approved':
      return (
        <Chip
          label="Aprovado"
          icon={<Done style={{ color: '#fff' }} />}
          style={{ background: green[700], color: '#fff', fontWeight: 'bold' }}
        />
      );

    case 'review':
      return (
        <Chip
          label="Aguardando revisão"
          icon={<Reviews style={{ color: '#fff' }} />}
          style={{ background: yellow[800], color: '#fff', fontWeight: 'bold' }}
        />
      );
    case 'archived':
      return (
        <Chip
          label="Arquivado"
          icon={<Archive style={{ color: '#fff' }} />}
          style={{ background: red[700], color: '#fff', fontWeight: 'bold' }}
        />
      );
    default:
      return null;
  }
};

export const getFileChip = (
  mimetype: string,
  originalName: string,
  path?: string,
  func?: any,
) => {
  switch (mimetype) {
    case 'image/png':
      return (
        <Chip
          label={originalName}
          variant="outlined"
          onClick={() => func(path)}
          clickable
          icon={<CropOriginal />}
        />
      );
    case 'image/jpeg':
      return (
        <Chip
          label={originalName}
          onClick={() => func(path)}
          variant="outlined"
          clickable
          icon={<Image style={{ color: `${theme.palette.secondary.main}` }} />}
        />
      );
    case 'application/pdf':
      return (
        <Chip
          label={originalName}
          onClick={() => func(path)}
          variant="outlined"
          clickable
          icon={
            <PictureAsPdf style={{ color: `${theme.palette.error.main}` }} />
          }
        />
      );
    case 'application/msword':
      return (
        <Chip
          label={originalName}
          variant="outlined"
          onClick={() => func(path)}
          clickable
          icon={
            <Description style={{ color: `${theme.palette.primary.main}` }} />
          }
        />
      );
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return (
        <Chip
          label={originalName}
          clickable
          onClick={() => func(path)}
          variant="outlined"
          icon={
            <Description style={{ color: `${theme.palette.primary.main}` }} />
          }
        />
      );

    default:
      return (
        <Chip
          label={originalName}
          variant="outlined"
          onClick={() => func(path)}
          clickable
          icon={<Attachment />}
        />
      );
  }
};
